import axios from "axios";

const FOOTER_SECTION_API_URL = `${process.env.REACT_APP_API_URL}/footer`; // Replace with your actual API URL

const customHeaders = {
  'Content-Type': 'application/json',
};

// Fetch all footer sections
export const fetchFooterSections = async () => {
  const response = await axios.get(`${FOOTER_SECTION_API_URL}`, { headers: customHeaders });
  return response.data;
};

// Create a new footer section
export const addFooterSection = async (newFooterSection: { title: string; description: string; is_active: boolean; image?: string }) => {
  const response = await axios.post(FOOTER_SECTION_API_URL, newFooterSection, { 
    headers: customHeaders
  });
  return response.data;
};

// Edit an existing footer section
export const updateFooterSection = async (updatedFooterSection: { title: string; description: string; is_active: boolean; image?: string }) => {
  const response = await axios.put(`${FOOTER_SECTION_API_URL}`, updatedFooterSection, { 
    headers: customHeaders
  });
  return response.data;
};
